/* ZCT_V26_FX (15.10.2026): Effekte wie die Referenz orchard.framer.website, angepasst an ZinCuTec. Plan: laeufe/fx/README.md.
   Alles nur Zusatz: ohne dieses Skript ist jeder Text und jedes Bild sofort sichtbar (die Wartezustände setzt erst das Skript, und nur
   für Elemente unterhalb des sichtbaren Bereichs). Bei „Bewegung reduzieren“ passiert nichts.
   Effekte (data-zd-fx, mehrere mit Leerzeichen):
   - text:   Wörter füllen sich beim Scrollen von 22 % auf 100 % Deckkraft (CSS view-timeline, sonst hier per Scroll-Position)
   - bild:   einmal beim Hineinscrollen, sobald das Bild geladen ist: Bild blendet auf und setzt sich (scale 1,06 → 1), 900 ms;
             ohne beschneidenden Rahmen steigt es stattdessen 16 px auf (der Zoom würde sonst über den Rand ragen)
   - gruppe: einmal beim Hineinscrollen: Kinder nacheinander (50 ms Versatz, höchstens 6 Stufen) aus 12 px nach oben, 420 ms,
             jedes Kind erst, wenn sein Bild geladen ist
   Nur opacity und transform-Teile: das rechnet die Grafikkarte, auch während des Scrollens am Handy (clip-path müsste jedes Bild neu malen).
   - parallax: nur CSS (zct-v26-fx.css)
   Die Stellen stehen unten in STELLEN; in Liquid kann data-zd-fx auch direkt gesetzt werden. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  // Am Rechner gleiten beim Scrollen Kacheln unter dem stehenden Mauszeiger durch und lösen ihre Hover-Effekte aus (Zoom, zweites Bild).
  // Solange gescrollt wird, nehmen die Bildkacheln keine Maus an (Klasse zd-scrollt, CSS in zct-v26-fx.css); 150 ms nach dem letzten Scrollen wieder normal.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var ruhe = 0, scrollt = false, wurzel = document.documentElement;
    window.addEventListener('scroll', function () {
      if (!scrollt) { scrollt = true; wurzel.classList.add('zd-scrollt'); }
      clearTimeout(ruhe); ruhe = setTimeout(function () { scrollt = false; wurzel.classList.remove('zd-scrollt'); }, 150);
    }, { passive: true });
  }
  // Zweitbilder für den Hover (Produktkarten, ph-Zweitbild) nur auf Geräten mit Maus laden; am Handy werden sie nie gezeigt.
  // Bis 16.10.2026 lud jede Karte überall ein zweites Bild mit. Karten, die später kommen (Filter), holt der MutationObserver.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var ZWEIT = '.card img.hover-img[data-zd-src], .ph img.alt[data-zd-src]';
    var zweitAn = function (i) {
      if (i.getAttribute('data-zd-srcset')) i.setAttribute('srcset', i.getAttribute('data-zd-srcset'));
      i.setAttribute('src', i.getAttribute('data-zd-src')); i.removeAttribute('data-zd-src'); i.removeAttribute('data-zd-srcset');
    };
    document.querySelectorAll(ZWEIT).forEach(zweitAn);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches(ZWEIT)) zweitAn(n); else if (n.firstElementChild) n.querySelectorAll(ZWEIT).forEach(zweitAn);
      }); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  // Bildgröße aus der echten Kachel (Bilder-Ladezeit 16.10.2026): Bilder mit data-zd-a (Seitenverhältnis b/h des Bildes), deren Kachelhöhe
  // vom Bildschirm abhängt und die per object-fit: cover zugeschnitten werden (ZEN-Galerie, TUKKON, Geschichte). sizes = nötige Breite,
  // höchstens der bisherige sizes-Wert: nie mehr Pixel als vorher, nie weniger als zu sehen sind. Läuft vor dem Laden (lazy, unterhalb).
  function sizesPx(s) {
    var teile = s.split(/,(?![^(]*\))/);
    for (var k = 0; k < teile.length; k++) {
      var t = teile[k].trim(), m = t.match(/^(\(.*\))\s+(.+)$/), l = m ? m[2] : t;
      if (m && !window.matchMedia(m[1]).matches) continue;
      var n = parseFloat(l); return /vw$/.test(l) ? n / 100 * window.innerWidth : /px$/.test(l) ? n : null;
    }
    return null;
  }
  document.querySelectorAll('img[data-zd-a]').forEach(function (i) {
    if (i.complete && i.naturalWidth) return;
    var r = i.getBoundingClientRect(), a = parseFloat(i.getAttribute('data-zd-a'));
    if (!r.width || !r.height || !a) return;
    var noetig = /contain/.test(getComputedStyle(i).objectFit) ? r.width : Math.max(r.width, r.height * a), bisher = sizesPx(i.getAttribute('sizes') || '100vw');
    noetig *= 1.2; // 20 % Reserve: Schärfe bei körnigen Fotos (Bildpaare im Bericht)
    i.setAttribute('sizes', Math.ceil(bisher ? Math.min(noetig, bisher) : noetig) + 'px');
  });
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var handy = window.matchMedia('(max-width: 768px)');
  var KURVE = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var STELLEN = [
    ['text', '.zd-k-statement, .tukkon-character-txt p, .tukkon-vogue-txt p, .zd-bh-statement, .manifesto-quote, .quote blockquote, .quote-text blockquote'],
    ['bild', '.zd-behind-panel, .split .img, .zd-bs-story-bild > img, .zen-gallery .gal-item, .tukkon-character-img, .zd-bh-bilder-reihe > figure > img, .zd-bh-film, .story-row .story-img, .zct-j-body figure > img, .zd-geschichte-gross figure > img, .zd-weitere'],
    ['gruppe', '.cats, .zd-reihe .grid, .zd-bk-raster, .zd-bh-objekte-raster, .zd-bh-journal-liste, .pdp-cross-sell .grid']
  ];
  // nie auf Kauf-Bereichen und nie im Kopf, Menü oder Fuß
  var TABU = '.pdp .info, .zd-pdp, .zd-kauf, .zd-kauf-karte, .drawer, .nav, .overlay-menu, .zd-ebene, footer, .zct-section-fuss, .zenroom .stage';

  function markieren() {
    STELLEN.forEach(function (s) {
      document.querySelectorAll(s[1]).forEach(function (e) {
        if (e.closest(TABU)) return;
        var alt = (e.getAttribute('data-zd-fx') || '').split(' ');
        if (alt.indexOf(s[0]) < 0) e.setAttribute('data-zd-fx', (alt.join(' ') + ' ' + s[0]).trim());
      });
    });
  }

  // ---------- bild und gruppe: einmal beim Hineinscrollen, erst wenn die Bilder da sind (WAAPI, berührt keine CSS-Übergänge) ----------
  function hauptbild(e) { return e.tagName === 'IMG' ? e : e.querySelector('img:not(.hover-img):not(.alt)'); }
  // Bild geladen und dekodiert, sonst blendet eine leere Kachel ein und das Foto springt hinterher. Höchstens 4 s warten (langsames Netz).
  function bereit(img) {
    if (!img) return Promise.resolve();
    return new Promise(function (ok) {
      var erledigt = false, frist = setTimeout(los, 4000);
      function los() { if (erledigt) return; erledigt = true; clearTimeout(frist); ok(); }
      function dekodieren() { if (img.decode) img.decode().then(los, los); else los(); }
      if (img.complete && img.naturalWidth) dekodieren();
      else { img.addEventListener('load', dekodieren, { once: true }); img.addEventListener('error', los, { once: true }); }
    });
  }
  // in waagerechten Reihen zählen nur Kinder bis eine halbe Breite neben dem Bildschirm; die hinteren laden wie bisher erst beim Wischen
  function nahe(k) { var r = k.getBoundingClientRect(), b = window.innerWidth; return r.right > -b / 2 && r.left < b * 1.5; }
  // eine Bildschirmhöhe vorher laden (Safari lädt „lazy“ erst sehr spät), damit beim Hineinscrollen nichts mehr fehlt
  function vorladen(e) {
    var bilder = /\bgruppe\b/.test(e.getAttribute('data-zd-fx')) ? Array.prototype.filter.call(e.children, nahe).map(hauptbild) : [hauptbild(e)];
    bilder.forEach(function (img) { if (img && img.loading === 'lazy') img.loading = 'eager'; });
  }
  function gerahmt(img) { // sitzt das Bild in einem Rahmen, der beschneidet? Dann bleibt der Zoom im Bild.
    for (var x = img.parentElement, n = 0; x && n < 2; x = x.parentElement, n++) {
      var cs = getComputedStyle(x); if (/hidden|clip/.test(cs.overflowX) && /hidden|clip/.test(cs.overflowY)) return true;
    }
    return false;
  }
  function bildAn(e) {
    var img = hauptbild(e), dauer = handy.matches ? 700 : 900;
    if (img) {
      var zoom = img.getAttribute('data-zd-fx-ziel') === 'zoom', gross = handy.matches ? '1.04' : '1.06';
      img.animate(zoom ? [{ opacity: 0, scale: gross }, { opacity: 1, scale: '1' }] : [{ opacity: 0, translate: '0 16px' }, { opacity: 1, translate: '0 0' }],
        { duration: dauer, easing: KURVE, fill: 'backwards' });
    }
    e.removeAttribute('data-zd-fx-warte');
  }
  function gruppeAn(e) {
    var weg = handy.matches ? '8px' : '12px', start = performance.now(), kinder = Array.prototype.slice.call(e.children), offen = kinder.length;
    if (!offen) { e.removeAttribute('data-zd-fx-warte'); return; }
    var warten = kinder.map(nahe); // jedes nahe Kind wartet auf sein eigenes Bild, ein langsames hält die anderen nicht auf
    kinder.forEach(function (k, i) {
      bereit(warten[i] ? hauptbild(k) : null).then(function () {
        k.setAttribute('data-zd-fx-los', '');
        var verzug = Math.max(0, start + Math.min(i, 6) * 50 - performance.now()); // Reihenfolge bleibt, wer später fertig ist, kommt sofort
        k.animate([{ opacity: 0, translate: '0 ' + weg }, { opacity: 1, translate: '0 0' }], { duration: 420, delay: verzug, easing: KURVE, fill: 'backwards' });
        if (--offen === 0) { e.removeAttribute('data-zd-fx-warte'); kinder.forEach(function (x) { x.removeAttribute('data-zd-fx-los'); }); }
      });
    });
  }
  function zeigen(e) {
    var f = e.getAttribute('data-zd-fx');
    if (/\bbild\b/.test(f)) bereit(hauptbild(e)).then(function () { bildAn(e); });
    if (/\bgruppe\b/.test(f)) gruppeAn(e);
  }
  function eingang() {
    if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (!x.isIntersecting) return; io.unobserve(x.target); zeigen(x.target); });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
    var vor = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (!x.isIntersecting) return; vor.unobserve(x.target); vorladen(x.target); });
    }, { rootMargin: '0px 0px 100% 0px', threshold: 0 });
    // Erste Einordnung ohne erzwungenes Layout: ein Beobachter ohne Rand meldet einmal je Element, wo es steht.
    // Nur was ganz unterhalb des Bildschirms liegt, bekommt den Wartezustand (noch nicht zu sehen, also kein Sprung).
    var erst = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        var e = x.target; erst.unobserve(e);
        if (x.isIntersecting || x.boundingClientRect.top < (x.rootBounds ? x.rootBounds.bottom : window.innerHeight)) return; // im Bild oder darüber: bleibt ruhig
        if (/\bbild\b/.test(e.getAttribute('data-zd-fx'))) { var img = hauptbild(e); if (img) img.setAttribute('data-zd-fx-ziel', gerahmt(img) ? 'zoom' : 'heben'); }
        e.setAttribute('data-zd-fx-warte', '');
        io.observe(e); vor.observe(e);
      });
    });
    document.querySelectorAll('[data-zd-fx~="bild"], [data-zd-fx~="gruppe"]').forEach(function (e) { erst.observe(e); });
    // Sicherung: ganz unten auf der Seite erscheint alles, was noch wartet (kein Element bleibt versteckt)
    window.addEventListener('scroll', function unten() {
      if (window.scrollY + window.innerHeight < document.documentElement.scrollHeight - 4) return;
      document.querySelectorAll('[data-zd-fx-warte]').forEach(function (e) { io.unobserve(e); vor.unobserve(e); vorladen(e); zeigen(e); });
      window.removeEventListener('scroll', unten);
    }, { passive: true });
  }

  // ---------- text: Wörter in Spans (Text bleibt im HTML gleich), Füllung an die Scroll-Position gebunden ----------
  var CSS_TIMELINE = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  function zerlegen(e) {
    var w = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null), knoten = [], n;
    while ((n = w.nextNode())) if (n.nodeValue.trim()) knoten.push(n);
    var woerter = [];
    knoten.forEach(function (t) {
      var teile = t.nodeValue.split(/(\s+)/), frag = document.createDocumentFragment();
      teile.forEach(function (s) {
        if (!s) return;
        if (/^\s+$/.test(s)) { frag.appendChild(document.createTextNode(s)); return; }
        var sp = document.createElement('span'); sp.className = 'zd-wort'; sp.textContent = s; frag.appendChild(sp); woerter.push(sp);
      });
      t.parentNode.replaceChild(frag, t);
    });
    e.setAttribute('data-zd-fx-bereit', '');
    return woerter;
  }
  // Füllung zwischen 8 % und 45 % des Weges durch den Bildschirm (fertig, wenn der Block die Mitte erreicht), je Wort 10 %.
  // Steht ein Block so weit unten, dass er die Mitte nie erreicht (Seitenende), endet die Füllung dort, wo er höchstens hinkommt.
  // fuellEnde liest (Layout), setzen schreibt: erst alle lesen, dann alle schreiben, damit der Start nur einmal Layout rechnet.
  function fuellEnde(e) { // Prozent des Weges, an dem das letzte Wort voll ist
    var vh = window.innerHeight, r = e.getBoundingClientRect(), oben = r.top + window.scrollY;
    var maxOben = oben - (document.documentElement.scrollHeight - vh); // Lage des Blocks ganz unten auf der Seite
    var maxP = (vh - maxOben) / (vh + r.height) * 100;
    return Math.max(12, Math.min(45, maxP - 4));
  }
  function setzen(woerter, ende) {
    var anfang = Math.min(8, ende / 4), spanne = Math.min(10, ende - anfang);
    var anz = woerter.length;
    woerter.forEach(function (sp, i) {
      var a = anfang + (ende - spanne - anfang) * i / Math.max(1, anz - 1);
      sp.style.setProperty('--a', a.toFixed(1)); sp.style.setProperty('--b', (a + spanne).toFixed(1));
      sp._a = a; sp._b = a + spanne;
    });
  }
  function imScrollbereich(e) {
    for (var x = e.parentElement; x && x !== document.body && x !== document.documentElement; x = x.parentElement) {
      var cs = getComputedStyle(x);
      if (/(auto|scroll|hidden)/.test(cs.overflowX + ' ' + cs.overflowY)) return true;
    }
    return false;
  }
  // Schrift noch nicht geladen und Block schon fertig gefüllt im Bild (z. B. ZEN-Einleitung ganz oben am Handy): erst nach der Schrift zerlegen.
  // Sonst verschiebt der Schriftwechsel einzelne Wörter, und Chrome zählt das als Layoutverschiebung (ein Textblock ohne Spans zählt nicht).
  // Sichtbar ändert sich dabei nichts, weil der Block an dieser Stelle ohnehin voll ist.
  function spaeter(e) {
    var r = e.getBoundingClientRect(), vh = window.innerHeight;
    if (r.top >= vh || r.bottom <= 0 || !document.fonts || !document.fonts.check) return false;
    var cs = getComputedStyle(e), schrift = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    try { if (document.fonts.check(schrift)) return false; } catch (x) { return false; }
    return (vh - r.top) / (vh + r.height) * 100 >= fuellEnde(e) ? schrift : false;
  }
  function textAn() {
    var bloecke = [], js = [], aktiv = [], geplant = false, io = null;
    function verarbeiten(liste) {
      var bl = liste.map(function (e) { return { e: e, w: zerlegen(e) }; });                       // schreiben
      bl.forEach(function (b) {                                                                       // lesen
        b.ende = fuellEnde(b.e);
        // CSS übernimmt (zct-v26-fx.css), außer der Block liegt in einem eigenen Scrollbereich (z. B. overflow-x: hidden aus dem alten Theme):
        // dort hinge die CSS-Zeitleiste an einem Bereich, der nie scrollt. Solche Blöcke und Browser ohne view-timeline rechnet das Skript.
        b.js = !CSS_TIMELINE || imScrollbereich(b.e);
        var r = b.e.getBoundingClientRect(); b.sicht = r.top < window.innerHeight && r.bottom > 0;
      });
      bl.forEach(function (b) {                                                                       // schreiben
        setzen(b.w, b.ende); bloecke.push(b);
        if (!b.js) return;
        b.e.setAttribute('data-zd-fx-js', ''); js.push(b);
        if (!io) rechnerAn();
        io.observe(b.e);
        if (b.sicht) aktiv.push(b); // schon im Bild: Werte sofort setzen, sonst stünde der Block bis zum nächsten Bild auf 0,22
      });
      if (bl.some(function (b) { return b.js && b.sicht; })) rechnen();
    }
    var jetzt = [];
    document.querySelectorAll('[data-zd-fx~="text"]').forEach(function (e) {
      var schrift = spaeter(e);
      if (!schrift) { jetzt.push(e); return; }
      document.fonts.load(schrift).then(function () { return document.fonts.ready; }).then(function () { verarbeiten([e]); }, function () { verarbeiten([e]); });
    });
    verarbeiten(jetzt);
    // nach dem Laden aller Bilder ändern sich die Höhen: Bereiche einmal neu setzen (erst lesen, dann schreiben)
    window.addEventListener('load', function () {
      var enden = bloecke.map(function (b) { return fuellEnde(b.e); });
      bloecke.forEach(function (b, i) { setzen(b.w, enden[i]); });
    });
    function rechnen() {
      geplant = false;
      var vh = window.innerHeight;
      var lagen = aktiv.map(function (b) { var r = b.e.getBoundingClientRect(); return (vh - r.top) / (vh + r.height) * 100; });
      aktiv.forEach(function (b, i) {
        var p = lagen[i];
        b.w.forEach(function (sp) {
          var o = Math.max(0, Math.min(1, (p - sp._a) / (sp._b - sp._a))), v = (0.22 + 0.78 * o).toFixed(2);
          if (sp._v !== v) { sp._v = v; sp.style.opacity = v; }
        });
      });
    }
    function planen() { if (!geplant) { geplant = true; requestAnimationFrame(rechnen); } }
    function rechnerAn() {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          var b = js.filter(function (y) { return y.e === x.target; })[0], i = aktiv.indexOf(b);
          if (x.isIntersecting && i < 0) aktiv.push(b);
          if (!x.isIntersecting) {
            if (i >= 0) aktiv.splice(i, 1);
            // übersprungen (Ende-Taste, Anker, Zurück-Knopf): über dem Bildschirm voll, darunter blass, wie beim Durchscrollen
            if (b) { var voll = x.boundingClientRect.bottom <= 0; b.w.forEach(function (sp) { var v = voll ? '1.00' : '0.22'; if (sp._v !== v) { sp._v = v; sp.style.opacity = v; } }); }
          }
        });
        planen();
      });
      window.addEventListener('scroll', planen, { passive: true });
      window.addEventListener('resize', planen, { passive: true });
    }
  }

  function start() { markieren(); eingang(); textAn(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
